import React, { FC } from 'react';

import { useUser } from '../../lib/hooks/user';


type Props = {
    isOpen: boolean;
    onClick(): void;
};


export const Menus: FC<Props> = ({ isOpen, onClick }) => {
    const user = useUser();

    return (
        <div className={['menus', isOpen ? 'open' : ''].join(' ')}>
            <div className="menus-inner">
                <div className="menu-contents">
                    <div className="menu-content">
                        {user.id && (
                            <a href="/mypages/menu">
                                {user.facebookId ? (
                                    <img
                                        className="icon profile-icon"
                                        src={`/user_icons/get/dummy?user_id=${user.id}`}
                                        alt="Facebookプロフィール画像"
                                    />
                                ) : (
                                    <img
                                        className="icon profile-icon"
                                        src={user.icon_path}
                                        alt="プロフィール画像"
                                    />
                                )}
                                <span>マイページ</span>
                                <img src="/img/menu/icon-menu-arrow.png" />
                            </a>
                        )}
                        <a href="/nishino">
                            <img src="/img/home.png" />
                            <span>ホーム</span>
                            <img src="/img/menu/icon-menu-arrow.png" />
                        </a>
                        <a href="/articles">
                            <img src="/img/article.png" />
                            <span>サロン記事</span>
                            <img src="/img/menu/icon-menu-arrow.png" />
                        </a>
                        <a href="/present_projects/">
                            <img src="/img/present.png" />
                            <span>プレゼント</span>
                            <img src="/img/menu/icon-menu-arrow.png" />
                        </a>
                        <a href="/coupon_list">
                            <img src="/img/coupon.png" />
                            <span>クーポン</span>
                            <img src="/img/menu/icon-menu-arrow.png" />
                        </a>
                        <a href="/map">
                            <img src="/img/map2.png" />
                            <span>チムニーマップ</span>
                            <img src="/img/menu/icon-menu-arrow.png" />
                        </a>
                        <a href="/stores/near">
                            <img src="/img/search.png" />
                            <span>近くのストア</span>
                            <img src="/img/menu/icon-menu-arrow.png" />
                        </a>
                        <a href="/members">
                            <img src="/img/members.png" />
                            <span>サロンメンバーを探す</span>
                            <img src="/img/menu/icon-menu-arrow.png" />
                        </a>
                        <a href="/manuals">
                            <img src="/img/icon_beginner.png" />
                            <span>使い方マニュアル</span>
                            <img src="/img/menu/icon-menu-arrow.png" />
                        </a>
                        {user.isCorpUser && (
                            <a href="/corporations/users/userSetting">
                                <img src="/img/member.png" />
                                <span>ユーザー情報設定</span>
                                <img src="/img/menu/icon-menu-arrow.png" />
                            </a>
                        )}
                        {user.isCorpUser && user.isStaff && (
                            <a href="/corporations/staffs/">
                                <img src="/img/menu/icon-menu-corp.png" />
                                <span>法人会員管理</span>
                                <img src="/img/menu/icon-menu-arrow.png" />
                            </a>
                        )}
                        {user.isOwner && (
                            <a href="/owners">
                                <img src="/img/menu/icon-menu-salon.png" />
                                <span>サロンオーナー</span>
                                <img src="/img/menu/icon-menu-arrow.png" />
                            </a>
                        )}
                        {user.id && (
                            <a href="/authentications/logout">
                                <img src="/img/menu/icon-menu-logout.png" />
                                <span>ログアウト</span>
                                <img src="/img/menu/icon-menu-arrow.png" />
                            </a>
                        )}
                    </div>
                </div>
            </div>

            <style jsx>{`
                a {
                    text-decoration: none;
                    color: black;
                }
                ul {
                    list-style-type: none;
                    padding-left: 0;
                }
                .menus {
                    max-width: 360px;
                    width: 85%;
                    height: 100vh;
                    position: fixed;
                    top: 0;
                    right: -85%;
                    z-index: 9;
                    padding: 0px;
                    font-size: 14px;
                    font-family: "Roboto";
                    transition: 0.5s;
                }
                .menus.open {
                    right: 0;
                }
                .menus-inner {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: start;
                    align-items: center;
                    padding: 5em 18px 0;
                    background-color: #FFFFFF;
                    overflow: auto;
                }
                .title {
                    font-size: 20pt;
                    padding-bottom: 6px;
                }
                .menu-contents {
                    width: 100%;
                }
                .menu-content {
                    display: block;
                    font-size: 15pt;
                }
                .menu-content > a {
                    display: flex;
                    align-items: center;
                    padding: 10px;
                }
                .menu-content > a + a {
                    border-top: 1px solid silver;
                }
                .menu-content > a > span {
                    flex-grow: 1;
                }
                .menu-content > a > img {
                    width: 30px;
                }
                .menu-content > a > img:first-of-type {
                    width: 60px;
                    margin-right: 30px;
                }
                .menu-content > a > .profile-icon {
                    border-radius: 50%;
                    border: solid 1px #AFAFAF;
                }
                @media screen and (max-width: 540px) {
                    .menu-content {
                        font-size: 13pt;
                    }
                    .menu-content > a {
                        padding: 5px;
                    }
                    .menu-content > a > img:first-of-type {
                         margin-right: 20px;
                    }
                }
            `}</style>
        </div>
    );
};
